import ContractsFooter from "./ContractsFooter";

export default ContractsFooter;
